module.exports = __webpack_public_path__ + "img/pic10.2ad5f84b.png";